export default __webpack_public_path__ + "static/testimonial__2-11a2b0e0385368185f304c44248d82d6.jpg";